import React from 'react';
import moment from 'moment';
import UIHelper from 'helpers/UIHelper';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const displayDate = (value) => {
  if (value && moment(value).isValid()) {
    return moment(value).format('DD MMMM YYYY');
  }
  return UIHelper.formatedDate(value) || '—';
};

const fileField = (item, onDownloadFile, t) => {
  const fileUrl = item?.file?.file_url;
  const fileName = item?.file?.file_name;

  if (!fileUrl) {
    return '—';
  }

  return (
    <a
      href={fileUrl}
      onClick={(e) => {
        e.preventDefault();
        onDownloadFile?.(fileUrl, fileName);
      }}
    >
      {fileName || t('Scarica file')}
    </a>
  );
};

export const getLeasingPlanViewSections = (t, item, { onDownloadFile } = {}) => {
  if (!item?.id) {
    return [];
  }

  return [
    {
      title: t('Info'),
      fields: [
        { text: t('Titolo'), value: display(item.title) },
        {
          text: t('Asset'),
          value: display(
            item.leasings_asset ||
              item['leasings_assets.title'] ||
              item.leasings_assets?.title,
          ),
        },
        {
          text: t('Data pubblicazione'),
          value: displayDate(item.day),
        },
        {
          text: t('Data'),
          value: displayDate(item.created_at),
        },
      ],
    },
    {
      title: t('Allegato'),
      fields: [
        {
          text: t('File'),
          value: fileField(item, onDownloadFile, t),
        },
      ],
    },
  ];
};
